const getCurrentTimeStamp = () => {
    let date = new Date();
    let CETTime =
    date.toLocaleString("en-US", {
        timeZone: "Europe/Brussels"
    });
    return CETTime
}

export {getCurrentTimeStamp}